import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  background: #0f172a;
  color: #e2e8f0;
`;

export const Header = styled.header`
  background: #1e293b;
  padding: 20px 40px;
  border-bottom: 1px solid #334155;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  h1 {
    font-size: 24px;
    color: white;
    margin: 0;
    font-weight: 600;
  }

  span {
    background: #3b82f6;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 24px;

  a {
    color: #94a3b8;
    text-decoration: none;
    font-size: 14px;

    &:hover {
      color: white;
    }
  }
`;

export const Main = styled.main`
  display: flex;
  max-width: 1400px;
  margin: 0 auto;
`;

export const Sidebar = styled.aside`
  width: 280px;
  padding: 32px 24px;
  border-right: 1px solid #334155;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;

  h3 {
    font-size: 12px;
    text-transform: uppercase;
    color: #64748b;
    margin: 24px 0 12px;
    letter-spacing: 0.05em;
  }

  &:first-child h3 {
    margin-top: 0;
  }
`;

export const NavItem = styled.a`
  display: block;
  padding: 8px 12px;
  color: ${(props) => (props.$active ? "#3b82f6" : "#94a3b8")};
  text-decoration: none;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #1e293b;
    color: white;
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 32px 48px;
  max-width: 900px;
`;

export const Section = styled.section`
  margin-bottom: 64px;

  h2 {
    font-size: 28px;
    color: white;
    margin: 0 0 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #334155;
  }

  h3 {
    font-size: 20px;
    color: white;
    margin: 32px 0 16px;
  }

  p {
    color: #94a3b8;
    line-height: 1.7;
    margin: 16px 0;
  }
`;

export const EndpointCard = styled.div`
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  margin: 24px 0;
  border: 1px solid #334155;
`;

export const EndpointHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #0f172a;
  border-bottom: 1px solid #334155;
`;

export const MethodBadge = styled.span`
  background: ${(props) => {
    switch (props.$method) {
      case "GET":
        return "#10b981";
      case "POST":
        return "#3b82f6";
      case "PUT":
        return "#f59e0b";
      case "DELETE":
        return "#ef4444";
      default:
        return "#6b7280";
    }
  }};
  color: white;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  font-family: monospace;
`;

export const EndpointPath = styled.code`
  color: #e2e8f0;
  font-size: 14px;
`;

export const EndpointBody = styled.div`
  padding: 20px;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 1px solid #334155;
  margin-bottom: 16px;
`;

export const Tab = styled.button`
  background: ${(props) => (props.$active ? "#334155" : "transparent")};
  border: none;
  color: ${(props) => (props.$active ? "white" : "#64748b")};
  padding: 10px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    color: white;
  }
`;

export const CodeBlock = styled.div`
  position: relative;
  background: #0d1117;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #30363d;
`;

export const CodeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background: #161b22;
  border-bottom: 1px solid #30363d;
`;

export const CopyButton = styled.button`
  background: transparent;
  border: 1px solid #30363d;
  color: #8b949e;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s;

  &:hover {
    background: #21262d;
    border-color: #8b949e;
    color: #c9d1d9;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const CodeContainer = styled.div`
  display: flex;
  overflow-x: auto;
  direction: ltr;
  text-align: left;
`;

export const LineNumbers = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  background: #0d1117;
  border-right: 1px solid #21262d;
  user-select: none;
  min-width: 50px;
  text-align: right;
  direction: ltr;
`;

export const LineNumber = styled.span`
  padding: 0 12px;
  font-family: "JetBrains Mono", "Fira Code", "Monaco", monospace;
  font-size: 13px;
  line-height: 1.5;
  color: #484f58;
`;

export const Pre = styled.pre`
  margin: 0;
  padding: 16px;
  overflow-x: auto;
  font-size: 13px;
  line-height: 1.5;
  flex: 1;
  direction: ltr;
  text-align: left;

  code {
    font-family: "JetBrains Mono", "Fira Code", "Monaco", monospace;
    color: #c9d1d9;
    direction: ltr;
    unicode-bidi: bidi-override;
  }
`;

export const ParamsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 16px 0;

  th,
  td {
    text-align: left;
    padding: 12px;
    border-bottom: 1px solid #334155;
  }

  th {
    color: #64748b;
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
  }

  td {
    font-size: 14px;
  }

  td:first-child {
    font-family: monospace;
    color: #f472b6;
  }

  td:nth-child(2) {
    color: #fbbf24;
    font-family: monospace;
  }
`;

export const RequiredBadge = styled.span`
  background: #ef4444;
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  margin-left: 8px;
`;

export const OptionalBadge = styled.span`
  background: #475569;
  color: #94a3b8;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  margin-left: 8px;
`;

export const Alert = styled.div`
  background: ${(props) =>
    props.$type === "warning"
      ? "rgba(251, 191, 36, 0.1)"
      : "rgba(59, 130, 246, 0.1)"};
  border: 1px solid
    ${(props) => (props.$type === "warning" ? "#fbbf24" : "#3b82f6")};
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;

  strong {
    color: ${(props) => (props.$type === "warning" ? "#fbbf24" : "#3b82f6")};
  }

  p {
    margin: 8px 0 0;
    color: #e2e8f0;
  }
`;
